import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatLegacyCheckboxModule } from "@angular/material/legacy-checkbox";
import { MatLegacyFormFieldModule } from "@angular/material/legacy-form-field";
import { MatLegacyInputModule } from "@angular/material/legacy-input";
import { MatLegacyOptionModule } from "@angular/material/legacy-core";
import { MatLegacySelectModule } from "@angular/material/legacy-select";
import { TextFieldModule } from "@angular/cdk/text-field";
import { AddressBookSaveComponent } from "./address-book-save.component";
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatLegacyCheckboxModule,
    MatLegacyFormFieldModule,
    MatLegacyInputModule,
    MatLegacyOptionModule,
    MatLegacySelectModule,
    ReactiveFormsModule,
    TextFieldModule
  ],
  declarations: [AddressBookSaveComponent],
  exports: [AddressBookSaveComponent]
})
export class AddressBookSaveModule { }
